var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26609 12.4957L4.22609 9.64348H7.76L8.72 12.4957H10L6.61913 3H5.38087L2 12.4957H3.26609ZM6.01391 4.43304L7.43304 8.66261H4.55304L5.97913 4.43304H6.01391Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1463 11.6365C12.1463 11.6214 12.1463 11.5913 12.1463 11.5611C12.1463 11.2293 12.3801 10.9427 12.7647 10.9427C13.1192 10.9427 13.3831 11.1991 13.3831 11.5234C13.3831 11.8854 13.1116 12.1719 12.8627 12.4208L11.0754 14.2534V15H14.6652V14.0422H12.7421V13.997L13.7149 12.9563C14.1297 12.5189 14.5822 12.1116 14.5822 11.4103C14.5822 10.6109 13.8808 10 12.7949 10C11.5656 10 11 10.7994 11 11.5762V11.6365H12.1463Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.c2a303f95d62f9935faea5e3767d1893.svg";
export { ForwardRef as ReactComponent };